/** Classes applied when a checkbox-styled control is in its highlighted "checked" visual state. */
export const CHECKBOX_CHECKED_CLASSNAMES = ['border-primary', 'bg-primary', 'text-primary-foreground'] as const;

/**
 * Base UI indicator for how a checkbox-styled control is visually highlighted.
 */
export function isCheckboxVisuallyChecked(checked: boolean, indeterminate?: boolean) {
  return checked && !indeterminate;
}
